module.exports = __webpack_public_path__ + "img/VIB_Logotype_BW.e13e04c.svg";